import axios from "axios";
import {
  FETCH_C_TERMS,
  CREATE_C_TERM,
  UPDATE_C_TERM,
  DELETE_C_TERM,
  interceptor
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);
export function addTerm(rt) {
  return {
    type: CREATE_C_TERM,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/contract_term/`, rt, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchTerms() {
  return {
    type: FETCH_C_TERMS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/contract_term/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateTerm(id, data) {
  return {
    type: UPDATE_C_TERM,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/contract_term/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteTerm(selected) {
  const ids = { ids: selected };
  return {
    type: DELETE_C_TERM,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/contract_term/delete/`, ids, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
